var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 451,
    height: 407,
    viewBox: "0 0 451 407",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168.535 391.438C94.4675 365.037 1.82936 268.987 0.952572 133.996C0.660359 88.5312 12.1513 55.1553 29.5898 33.1575C47.0248 11.1641 70.4239 0.516096 94.0347 0.516096C116.889 0.516096 139.987 10.5059 158.065 29.9207C185.955 59.8894 213.127 78.2786 240.957 88.5222C268.787 98.7655 297.239 100.85 327.669 98.2628C357.918 95.6992 390.911 105.228 415.072 127.098C439.216 148.953 454.577 183.169 449.522 230.074C444.466 276.981 414.865 331.824 366.194 367.687C317.547 403.533 249.844 420.423 168.535 391.438Z",
    stroke: "#CC99FF",
    strokeWidth: 1.03219
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector2);
export default __webpack_public_path__ + "static/media/vector2.a3f0d24056dc7c5864006b5dbe95b5b2.svg";
export { ForwardRef as ReactComponent };